<ng-select *ngIf="!isLoading else loading"
			[name]="name"
			[id]="id"
            bindLabel="text"
            bindValue="id"
			width="100%"
            [multiple]="multiple"
			[placeholder]="placeHolder | translate"
			[clearable]="allowClear"
			[(ngModel)]="value"
			[disabled]="disabled"
			(ngModelChange)="onNgModelChange()"
			[items]="variables">
    <ng-template ng-option-tmp let-item="item">
        <div>
            <img class="variable-select-icon" alt="Property" src="/ibpworkbench/controller/static/images/property.svg">
            <span> {{item.propertyName}} </span>
            @if (item.classes) {
                <span class="badge text-bg-secondary"> {{item.classes}} </span>
            }
        </div>
        <div>
            <img class="variable-select-icon" alt="Variable" src="/ibpworkbench/controller/static/images/variable.png">
            <span> {{item.displayName}} </span>
        </div>
    </ng-template>
</ng-select>
<ng-template #loading>
	<span class="throbber"></span>
</ng-template>
